import { IconProps } from '@euler/app/components/icons/types';
import { GradientIconProps } from '@euler/app/tv/theme/types';
import { FC, memo } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

export const TimeElapsedIcon: FC<IconProps & GradientIconProps> = memo(
  ({
    width,
    height,
    size = 16,
    color = 'rgba(255, 255, 255, 0.4)',
    startColor,
    endColor,
    style,
  }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 16 16"
        style={style}
      >
        <Path
          d="M8.87718 3.73213H8.01825C7.93968 3.73213 7.8754 3.79641 7.8754 3.87498V8.79106C7.8754 8.83749 7.89683 8.88034 7.93433 8.90713L10.8861 11.0625C10.9504 11.1089 11.0397 11.0964 11.0861 11.0321L11.5968 10.3357C11.645 10.2696 11.6308 10.1803 11.5665 10.1357L9.02004 8.29463V3.87498C9.02004 3.79641 8.95575 3.73213 8.87718 3.73213ZM12.8022 5.07499L15.6022 5.75891C15.6915 5.78034 15.779 5.71248 15.779 5.62141L15.7933 2.73748C15.7933 2.61784 15.6558 2.54998 15.5629 2.62498L12.7486 4.8232C12.7273 4.83965 12.7111 4.86178 12.7019 4.88702C12.6926 4.91227 12.6907 4.93962 12.6963 4.96592C12.7019 4.99223 12.7148 5.01641 12.7335 5.03571C12.7523 5.055 12.7761 5.06862 12.8022 5.07499ZM15.7968 10.4518L14.7843 10.1036C14.749 10.0915 14.7104 10.0936 14.6767 10.1097C14.643 10.1257 14.6169 10.1543 14.604 10.1893C14.57 10.2803 14.5343 10.3696 14.4968 10.4589C14.179 11.2107 13.7236 11.8875 13.1415 12.4678C12.5658 13.0453 11.8835 13.5056 11.1325 13.8232C10.3546 14.1521 9.51828 14.321 8.67361 14.3196C7.82004 14.3196 6.99325 14.1536 6.21468 13.8232C5.46368 13.5056 4.78143 13.0453 4.20575 12.4678C3.6254 11.8875 3.17004 11.2107 2.8504 10.4589C2.52328 9.68049 2.35569 8.84434 2.35754 7.99999C2.35754 7.14641 2.52361 6.31784 2.85397 5.53927C3.17183 4.78749 3.62718 4.1107 4.20933 3.53034C4.78501 2.95288 5.46725 2.49259 6.21826 2.17498C6.99326 1.84463 7.82183 1.67856 8.6754 1.67856C9.52897 1.67856 10.3558 1.84463 11.1343 2.17498C11.8853 2.49259 12.5676 2.95288 13.1433 3.53034C13.3254 3.71427 13.4968 3.90534 13.654 4.10713L14.7218 3.27141C13.3165 1.47498 11.129 0.319627 8.67183 0.321413C4.39325 0.323199 0.957539 3.7982 1.0004 8.07856C1.04325 12.2839 4.4629 15.6786 8.6754 15.6786C11.9879 15.6786 14.8093 13.5786 15.8843 10.6375C15.9111 10.5625 15.8718 10.4786 15.7968 10.4518Z"
          fill="url(#paint0_linear_371_4149)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_371_4149"
            x1="8.44637"
            y1="-3.19793"
            x2="8.44637"
            y2="15.6786"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor={startColor ?? color} />
            <Stop offset="1" stopColor={endColor ?? color} />
          </LinearGradient>
        </Defs>
      </Svg>
    );
  },
);
